import api from "./api";

const TOKEN_KEY = "ingroove_token";
const REFRESH_KEY = "ingroove_refresh";
const USER_KEY = "ingroove_user";

export const hubLogin = async (email, password) => {
  const response = await api.post("/authentication/hubLogin", { email, password });
  return response.data;
};

export const saveAuth = (authData) => {
  localStorage.setItem(TOKEN_KEY, authData.accessToken);
  localStorage.setItem(REFRESH_KEY, authData.refreshToken);
  localStorage.setItem(USER_KEY, JSON.stringify(authData.user));
};

export const clearAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_KEY);
  localStorage.removeItem(USER_KEY);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getUser = () => {
  try {
    const raw = localStorage.getItem(USER_KEY);
    if (!raw || raw === "undefined" || raw === "[object Object]") return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
};
